import { useMemo } from 'react';
import { useGetRecommendedProduct } from '~/api/hooks/useGetRecommendedProduct';
import { useRegion } from '~/features/region/hooks/useRegion';
import { useLocale } from '~/hooks/useLocale';
import { childGetters } from '~/recoil/child';
import { userGetters } from '~/recoil/user';
import { nowDate } from '~/utils/time';

/**
 * 製品推奨のSWRラッパー
 * user/locale/regionを内部で取得して useGetRecommendedProduct に渡す
 */
export const useProducts = (date: string = nowDate()) => {
  const user = userGetters.useValue();
  const { lang } = useLocale();
  const { regionCode } = useRegion();
  const isNewbie = childGetters.useIsFirstLogin(user.selected_child_id);

  const params = useMemo(
    () =>
      date && user?.selected_child_id
        ? { date, child_id: user.selected_child_id, lang, regionCode, is_newbie: isNewbie }
        : null,
    [date, user?.selected_child_id, lang, regionCode, isNewbie],
  );

  return useGetRecommendedProduct(params);
};
